import { render, staticRenderFns } from "./TelaLogin.vue?vue&type=template&id=4af8151c&scoped=true"
import script from "./TelaLogin.vue?vue&type=script&lang=js"
export * from "./TelaLogin.vue?vue&type=script&lang=js"
import style0 from "./TelaLogin.vue?vue&type=style&index=0&id=4af8151c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af8151c",
  null
  
)

export default component.exports